/**
 * Event utility functions for checking event status
 */

export interface EventStatusCheckable {
  started?: boolean;
  completed?: boolean;
  startDate?: Date;
  endDate?: Date;
}

/**
 * Checks if an event has started
 * @param event Event object with started flag and/or startDate
 * @returns true if event has started
 */
export const isEventStarted = (event: EventStatusCheckable | null | undefined): boolean => {
  if (!event) return false;
  return event.started || (event.startDate ? event.startDate <= new Date() : false);
};

/**
 * Checks if an event has completed
 * @param event Event object with completed flag and/or endDate
 * @returns true if event has completed
 */
export const isEventCompleted = (event: EventStatusCheckable | null | undefined): boolean => {
  if (!event) return false;
  return event.completed || (event.endDate ? event.endDate < new Date() : false);
};

/**
 * Checks if an event is currently active (started but not completed)
 * @param event Event object with status flags and dates
 * @returns true if event is active
 */
export const isEventActive = (event: EventStatusCheckable | null | undefined): boolean => {
  if (!event) return false;
  return isEventStarted(event) && !isEventCompleted(event);
};

